import { useEffect, useCallback, useRef } from 'react'
import { Events as EventsService } from '@services'
import axios from 'axios'
import {
  getSiteLanguage
} from '@utils'
import { logger } from '@dmi-mch/utils'

import { useModuleContext } from '../contexts/EventsContext'

const CancelToken = axios.CancelToken

const useEventsAndFiltersData = () => {
  //@ts-ignore
  const [{ events, router, CMSProps }, dispatch] = useModuleContext()
  const source = useRef(null)
  const eventsPrevPage = useRef([])

  // Pagination stuff
  const pageSize = 36
  const page = useRef(1)

  // Main Events fetch
  const fetch = useCallback(
    async () => {
      if (source.current) {
        //@ts-ignore
        source.current.cancel()
      }

      const offset = pageSize * (page.current - 1)
      const routerQuery = router.query
      routerQuery.orderBy = routerQuery.orderBy || 'endDate ASC,startDate ASC'

      if (routerQuery.endDate && routerQuery.endDate?.length > 0) {
        routerQuery.endDate = routerQuery.utm_source ? routerQuery.endDate[0] : routerQuery.endDate
      }

      delete routerQuery.slug
      delete routerQuery.utm_medium
      delete routerQuery.utm_campaign
      delete routerQuery.utm_content
      delete routerQuery.utm_source
      delete routerQuery.lang

      try {
        let params = {
          offset,
          limit: pageSize,
          locale: getSiteLanguage(),
          online: false,
          ...routerQuery
        }
        // pre-filter the event list by city. If the city is selected from cms EVS module.
        if (CMSProps.evg_grp1_city) {
          params.cityId = CMSProps.evg_grp1_city
        }
        /** END OF GENERATING PARAMS */
        //@ts-ignore
        source.current = CancelToken.source()
        //@ts-ignore
        const result = await EventsService.getUpcomingEvents({ params, cancelToken: source.current.token })

        if (result.ok) {
          dispatch({
            type: 'SET_EVENTS_PAGINATION_INFO',
            payload: {
              //@ts-ignore
              hasMore: result.data?.events.hasMore,
              //@ts-ignore
              offset: result.data?.events.offset,
              //@ts-ignore
              total: result.data?.events.total
            }
          })
          // @ts-ignore Sends data to the filters, without this, the filters can't be rendered
          dispatch({ type: 'SET_FILTERS_OPTIONS', payload: result.data.filters })
          // Spinners stuff
          dispatch({ type: 'SET_IS_LOADING_EVENTS', payload: false })
          // More spinners stuff
          dispatch({ type: 'SET_IS_LOADING_NEW_PAGE', payload: false })

          // @ts-ignore
          let eventsCopy = [...result.data.events.items]

          if (page.current > 1) {
            // @ts-ignore
            eventsCopy = [...eventsPrevPage.current, ...result.data.events.items]
          }

          dispatch({
            type: 'SET_EVENTS_LIST',
            payload: eventsCopy
          })
          typeof CMSProps.cbComponentReady === 'function' && CMSProps.cbComponentReady()
        }

      } catch (e) {
        logger(e)
      }
      source.current = null
    },
    [CMSProps, dispatch, router.query]
  )

  // Saving a copy of events every time. Will eventually be appended in case of pagination
  useEffect(() => {
    eventsPrevPage.current = events
  }, [events])

  // On every fetch caused by a change of route (which means a change of filters), set the page back to 1.
  useEffect(() => {
    page.current = 1
    fetch()
  }, [router, fetch])

  // Request new page, by increasing page by 1.
  const loadNextPage = useCallback(() => {
    dispatch({
      type: 'SET_IS_LOADING_NEW_PAGE',
      payload: true
    })
    page.current = page.current + 1
    fetch()
  }, [fetch, dispatch])



  return {
    loadNextPage
  }
}

export default useEventsAndFiltersData
